import { EventBus } from './EventBus';
import { HandleRegistry } from './HandleRegistry';
import { ParamStore } from './ParamStore';

export class EventScope {
  readonly scopeId: string;
  readonly bus: EventBus;
  readonly registry: HandleRegistry;
  readonly params: ParamStore;

  constructor(scopeId: string) {
    this.scopeId = scopeId;
    this.bus = new EventBus();
    this.registry = new HandleRegistry();
    this.params = new ParamStore();
  }

  dispose(): void {
    this.bus.dispose();
    this.registry.dispose();
    this.params.dispose();
  }
}
